import { jsx as _jsx } from "react/jsx-runtime";
/* istanbul ignore file */
import '@/app/global.css';
import { apolloClient } from '@/utils/apolloClient';
import renderComponent from '@/utils/renderComponent';
import '@/utils/sentry';
import { ApolloProvider } from '@apollo/client';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import OrganizersContainer from './components/OrganizersContainer/OrganizersContainer';
export var renderedComponent = function () {
    var queryClient = new QueryClient();
    renderComponent({
        component: (_jsx(ApolloProvider, { client: apolloClient, children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx(Sentry.ErrorBoundary, { children: _jsx(OrganizersContainer, {}) }) }) })),
        target: 'js-organizers-root',
    });
};
renderedComponent();
